module.exports = __webpack_public_path__ + "static/img/swiper_slide_bg.a37bee8.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/swiper_slide_bg.png
// module id = GwsQ
// module chunks = 0